import Computer from '@mui/icons-material/Computer';
import { MobileIcon } from '@openx/components-core/icons/MobileIcon/MobileIcon';
import { TVDevicesIcon } from '@openx/components-core/icons/TVDevicesIcon/TVDevicesIcon';
import type { RequiredTargetingFormType } from '@openx/types/targeting/targetingPresets';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type Section, TargetingElementKeys, type TargetingElementKeysType } from '../../context/types';
import { convertApiToSet } from '../../utils/convertApiToSet';

export const useReadOnlyDeviceInitialState = (
  targetingParams: RequiredTargetingFormType | null | undefined
): Section => {
  const { t } = useTranslation();

  return useMemo(() => {
    const formValue = targetingParams?.device_type;
    const initValues = convertApiToSet([formValue?.desktop_devices, formValue?.mobile_devices, formValue?.tv_devices]);
    const isSelected = (key: TargetingElementKeysType): boolean => initValues.has(key);

    return {
      label: t('Device'),
      isLoading: true,
      elements: [
        {
          mainOption: {
            key: TargetingElementKeys.DEVICE_DESKTOP,
            label: t('Desktop'),
            icon: <Computer />,
            isSelected: isSelected(TargetingElementKeys.DEVICE_DESKTOP),
            isDisabled: true,
          },
        },
        {
          mainOption: {
            key: TargetingElementKeys.DEVICE_MOBILE,
            label: t('Mobile'),
            icon: <MobileIcon />,
            isSelected:
              isSelected(TargetingElementKeys.DEVICE_MOBILE_SMARTPHONE) ||
              isSelected(TargetingElementKeys.DEVICE_MOBILE_TABLET),
            isDisabled: true,
          },
          subOptions: [
            {
              key: TargetingElementKeys.DEVICE_MOBILE_SMARTPHONE,
              label: t('Smart Phone'),
              isSelected: isSelected(TargetingElementKeys.DEVICE_MOBILE_SMARTPHONE),
              isDisabled: true,
            },
            {
              key: TargetingElementKeys.DEVICE_MOBILE_TABLET,
              label: t('Tablet'),
              isSelected: isSelected(TargetingElementKeys.DEVICE_MOBILE_TABLET),
              isDisabled: true,
            },
          ],
        },
        {
          mainOption: {
            key: TargetingElementKeys.DEVICE_TV,
            label: t('TV Devices'),
            icon: <TVDevicesIcon />,
            isSelected:
              isSelected(TargetingElementKeys.DEVICE_TV_CONNECTEDTV) ||
              isSelected(TargetingElementKeys.DEVICE_TV_SETTOPBOX),
            isDisabled: true,
          },
          subOptions: [
            {
              key: TargetingElementKeys.DEVICE_TV_CONNECTEDTV,
              label: t('Connected TV'),
              isSelected: isSelected(TargetingElementKeys.DEVICE_TV_CONNECTEDTV),
              isDisabled: true,
            },
            {
              key: TargetingElementKeys.DEVICE_TV_SETTOPBOX,
              label: t('Set Top Box'),
              isSelected: isSelected(TargetingElementKeys.DEVICE_TV_SETTOPBOX),
              isDisabled: true,
            },
          ],
        },
      ],
    };
  }, [t, targetingParams]);
};
